export default "__VITE_ASSET__b11bda5c__"